// Per-account calibrated seasonal curve. The ONLY place that talks to the
// `account_seasonal` table. The curve is a week-of-year array (index 1..52 used);
// absence means "use the engine's built-in default".

import { supabase } from "../../lib/supabase";

/** Load the account's saved seasonal curve, or null if none is set. */
export async function getSeasonal(accountId: string): Promise<number[] | null> {
  const { data, error } = await supabase
    .from("account_seasonal")
    .select("factors")
    .eq("account_id", accountId)
    .maybeSingle();
  if (error) throw error;
  const f = data?.factors;
  return Array.isArray(f) ? (f as number[]) : null;
}

/** Save (upsert) the account's seasonal curve. */
export async function saveSeasonal(accountId: string, factors: number[]): Promise<void> {
  const { error } = await supabase
    .from("account_seasonal")
    .upsert(
      { account_id: accountId, factors, updated_at: new Date().toISOString() },
      { onConflict: "account_id" }
    );
  if (error) throw error;
}

/** Remove the account's saved curve (revert to the default). */
export async function clearSeasonal(accountId: string): Promise<void> {
  const { error } = await supabase.from("account_seasonal").delete().eq("account_id", accountId);
  if (error) throw error;
}
